/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_ProductInputs */

const en_field_product = /** @type {(inputs: Field_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product`)
};

/**
* | output |
* | --- |
* | "Product" |
*
* @param {Field_ProductInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_product = /** @type {((inputs?: Field_ProductInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_ProductInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_product(inputs)
});